// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29roD","fullView":"styles_fullView__3Zl0Y"};